import React from 'react'
import './FrameWithButton.scss'
import { FrameName as frameName, FrameType } from 'types'

export interface Props {
  handleTouch: (e: React.TouchEvent<HTMLDivElement>) => void
  handleClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  handleWheel: (e: React.WheelEvent<HTMLDivElement>) => void
  currentFrame: frameName
  frames: FrameType
  barStyle: {}
  children?: React.ReactNode // Background, Images
}

export const FrameWithButton = ({
  handleTouch,
  handleClick,
  handleWheel,
  currentFrame,
  frames,
  barStyle,
  children,
}: Props) => {
  return (
    <div
      id="frame"
      className="frame"
      onTouchStart={e => handleTouch(e)}
      onTouchMove={e => handleTouch(e)}
      onWheel={e => handleWheel(e)}
    >
      <div
        id="frame_left"
        className="frame_left"
        style={{ backgroundImage: `url(${frames[currentFrame].leftSrc})` }}
      >
        <div className="btn btn_top" />
        <div className="btn btn_prev" />
      </div>

      <div className="title" />
      <div id="bar" className="bar" style={barStyle} />
      {children}

      <div
        id="frame_right"
        className="frame_right"
        style={{ backgroundImage: `url(${frames[currentFrame].rightSrc})` }}
      >
        <div className="btn btn_next" />
        <div className="btn btn_store" />
      </div>

      <div id="top" className="btn btn_top pesudo_btns" onClick={e => handleClick(e)} />
      <div id="prev" className="btn btn_prev pesudo_btns" onClick={e => handleClick(e)} />
      <div id="next" className="btn btn_next pesudo_btns" onClick={e => handleClick(e)} />
      <div id="store" className="btn btn_store pesudo_btns" onClick={e => handleClick(e)} />
    </div>
  )
}
